import Configs from '../../settings/Configs';
import IClass from "../IClass";
import moment from "moment";

class Logger {

    public static Log (value: any, logKey?: string, classRef?: IClass | string, supressUndefined: boolean = true) {
        if (Configs.ENABLE_LOG) {
            let c = Configs.COLORED_LOG;
            let c1 = c ? `\x1B[95m` : ``;
            let c2 = c ? `\x1B[34m` : ``;
            let c3 = c ? `\x1B[90m` : ``;
            let cX = c ? `\x1B[0m` : ``; 
            let time = moment().format("YYYY-MM-DD|HH:mm:ss");
            console.log(
                `[${time}]` +
                ((typeof window == 'undefined') ? ` ${c1}[Worker:${process.env.WORKER_ID}]${cX}` : ``) +
                ((classRef != undefined) ? ` ${c2}[${(typeof classRef == 'string') ? classRef : classRef.constructor.name}]${cX}` : ``) +
                ((logKey != undefined) ? ` ${c3}${logKey}${cX}` : ``),
                ((supressUndefined && value == undefined)) ? `` : value
            );
        }
    }
}

export default Logger;
